import { render, staticRenderFns } from "./add.vue?vue&type=template&id=855f4158&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855f4158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('855f4158')) {
      api.createRecord('855f4158', component.options)
    } else {
      api.reload('855f4158', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=855f4158&scoped=true", function () {
      api.rerender('855f4158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolUpdate/components/add.vue"
export default component.exports